
import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useEmail = (id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  const { set: setError } = useApiError();
  // //console.log("useEmailmethodcontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `useEmail-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useEmail-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useEmail-error-${id}`);
  // 刷新token
  const sendEmail = async (customQuery) => {
    loading.value = true;
    const res = await context.$xbuy.api.customEmail(customQuery);
    if (res.code === 0) {
      result.value = res.data;
      error.value = null;
      loading.value = false;
      setError({ code: res.code, message: res.message });
    } else {
      error.value = res.message;
      setError({ code: res.code, message: res.message });
    }
    // const data = await params.load(context);
    return res;
  };

  return {
    sendEmail,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
